"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.ableTo6mwtMessages = exports.AbleTo6mwt = void 0;
const schema_1 = require("../../../schema");
var AbleTo6mwt;
(function (AbleTo6mwt) {
    AbleTo6mwt["YES"] = "YES";
    AbleTo6mwt["NO"] = "NO";
})(AbleTo6mwt || (exports.AbleTo6mwt = AbleTo6mwt = {}));
exports.ableTo6mwtMessages = {
    [AbleTo6mwt.YES]: {
        id: "htx.currentCardiologicalState.6Mwt.ableTo6mwt.YES",
        defaultMessage: "Igen"
    },
    [AbleTo6mwt.NO]: {
        id: "htx.currentCardiologicalState.6Mwt.ableTo6mwt.NO",
        defaultMessage: "Nem"
    }
};
const ableTo6mwt = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AbleTo6mwt.YES),
    schema_1.Schema.singleChoiceItem(AbleTo6mwt.NO)
])
    .default(AbleTo6mwt.YES)
    .interpretation({ vocab: "htx", code: "able_to_6MWT" });
const value = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../ableTo6mwt} === "YES"`), schema_1.Schema.number()
    .unit("m")
    .min(0)
    .max(1000)
    .interpretation({ vocab: "htx", code: "6mwt" })
    .tag({ vocab: "snomed", code: "252478000" })
    .tag({ vocab: "loinc", code: "64098-7" })
    .tag({ vocab: "snomed", code: "243806009" }));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ ableTo6mwt, value });
